<!--begin::Modal - Add/Edit Courier Manager-->
<div class="modal fade" id="kt_modal_courier_manager_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Courier Manager' : 'Add Courier Manager' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="courierManagerForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Stock (Searchable) -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Stock</label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" [(ngModel)]="vehicleSearchTerm"
                  [ngModelOptions]="{standalone: true}" (input)="onVehicleSearchInput($event)"
                  (focus)="onVehicleInputFocus()" (blur)="onVehicleInputBlur()" placeholder="Search vehicles..."
                  autocomplete="off" [class.is-invalid]="vehicle_id?.invalid && vehicle_id?.touched"
                  [disabled]="isEditMode" />

                <!-- Vehicle Search Dropdown -->
                <div class="dropdown-menu show w-100 mh-300px overflow-auto" *ngIf="showVehicleDropdown && !isEditMode"
                  style="position: absolute; top: 100%; left: 0; z-index: 1000;">
                  <div class="dropdown-item text-center py-2" *ngIf="isVehicleSearching">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Searching...
                  </div>
                  <div class="dropdown-item text-center py-2 text-muted"
                    *ngIf="!isVehicleSearching && vehicleSearchResults.length === 0">
                    No vehicles found
                  </div>
                  <a href="#" class="dropdown-item py-2" *ngFor="let vehicle of vehicleSearchResults"
                    (click)="selectVehicle(vehicle); $event.preventDefault()">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <div class="fw-bold">{{ vehicle.car_no || vehicle.inventory_no || 'N/A' }}</div>
                        <div class="text-muted fs-7">{{ vehicle.name || 'Unknown Vehicle' }}</div>
                      </div>
                    </div>
                  </a>
                </div>

                <div class="invalid-feedback" *ngIf="vehicle_id?.invalid && vehicle_id?.touched">
                  <span *ngIf="vehicle_id?.errors?.['required']">Stock is required</span>
                </div>
              </div>
            </div>

            <!-- Customer Name -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Customer Name</label>
              <input type="text" class="form-control form-control-solid" formControlName="customer_name"
                placeholder="Enter customer name" [class.is-invalid]="customer_name?.invalid && customer_name?.touched" />
              <div class="invalid-feedback" *ngIf="customer_name?.invalid && customer_name?.touched">
                <span *ngIf="customer_name?.errors?.['required']">Customer name is required</span>
              </div>
            </div>

            <!-- Customer Email -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Customer Email</label>
              <input type="email" class="form-control form-control-solid" formControlName="customer_email"
                placeholder="Enter customer email" [class.is-invalid]="customer_email?.invalid && customer_email?.touched" />
              <div class="invalid-feedback" *ngIf="customer_email?.invalid && customer_email?.touched">
                <span *ngIf="customer_email?.errors?.['required']">Customer email is required</span>
                <span *ngIf="customer_email?.errors?.['email']">Please enter a valid email address</span>
              </div>
            </div>

            <!-- Customer Address -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Customer Address</label>
              <input type="text" class="form-control form-control-solid" formControlName="customer_address"
                placeholder="Enter customer address" [class.is-invalid]="customer_address?.invalid && customer_address?.touched" />
              <div class="invalid-feedback" *ngIf="customer_address?.invalid && customer_address?.touched">
                <span *ngIf="customer_address?.errors?.['required']">Customer address is required</span>
              </div>
            </div>

            <!-- Post/Zip Code -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Post/Zip Code</label>
              <input type="text" class="form-control form-control-solid" formControlName="post_zip_code"
                placeholder="Enter post/zip code" [class.is-invalid]="post_zip_code?.invalid && post_zip_code?.touched" />
              <div class="invalid-feedback" *ngIf="post_zip_code?.invalid && post_zip_code?.touched">
                <span *ngIf="post_zip_code?.errors?.['required']">Post/Zip code is required</span>
              </div>
            </div>

            <!-- Country -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Country</label>
              <select class="form-select form-select-solid" formControlName="country"
                [class.is-invalid]="country?.invalid && country?.touched">
                <option value="">Select Country</option>
                <option *ngFor="let country of countriesList" [value]="country.name">{{ country.name }}</option>
              </select>
              <div class="invalid-feedback" *ngIf="country?.invalid && country?.touched">
                <span *ngIf="country?.errors?.['required']">Country is required</span>
              </div>
            </div>

            <!-- Contact Person -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Contact Person</label>
              <input type="text" class="form-control form-control-solid" formControlName="contact_person"
                placeholder="Enter contact person" [class.is-invalid]="contact_person?.invalid && contact_person?.touched" />
              <div class="invalid-feedback" *ngIf="contact_person?.invalid && contact_person?.touched">
                <span *ngIf="contact_person?.errors?.['required']">Contact person is required</span>
              </div>
            </div>

            <!-- Phone No. -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Phone No.</label>
              <input type="text" class="form-control form-control-solid" formControlName="phone_no"
                placeholder="Enter phone number" [class.is-invalid]="phone_no?.invalid && phone_no?.touched" />
              <div class="invalid-feedback" *ngIf="phone_no?.invalid && phone_no?.touched">
                <span *ngIf="phone_no?.errors?.['required']">Phone number is required</span>
              </div>
            </div>

            <!-- Courier Company (Searchable) -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Courier Company</label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" [(ngModel)]="courierCompanySearchTerm"
                  [ngModelOptions]="{standalone: true}" (input)="onCourierCompanySearchInput($event)"
                  (focus)="onCourierCompanyInputFocus()" (blur)="onCourierCompanyInputBlur()"
                  placeholder="Search courier companies..." autocomplete="off"
                  [class.is-invalid]="courier_company_id?.invalid && courier_company_id?.touched" />

                <!-- Courier Company Search Dropdown -->
                <div class="dropdown-menu show w-100 mh-300px overflow-auto" *ngIf="showCourierCompanyDropdown"
                  style="position: absolute; top: 100%; left: 0; z-index: 1000;">
                  <div class="dropdown-item text-center py-2" *ngIf="isCourierCompanySearching">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Searching...
                  </div>
                  <div class="dropdown-item text-center py-2 text-muted"
                    *ngIf="!isCourierCompanySearching && courierCompanySearchResults.length === 0">
                    No courier companies found
                  </div>
                  <a href="#" class="dropdown-item py-2" *ngFor="let company of courierCompanySearchResults"
                    (click)="selectCourierCompany(company); $event.preventDefault()">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <div class="fw-bold">{{ company.company_name || company.name || 'Unknown Company' }}</div>
                      </div>
                    </div>
                  </a>
                </div>

                <div class="invalid-feedback" *ngIf="courier_company_id?.invalid && courier_company_id?.touched">
                  <span *ngIf="courier_company_id?.errors?.['required']">Courier company is required</span>
                </div>
              </div>
            </div>

            <!-- Order Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Order Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="order_date" />
            </div>

            <!-- Surrender Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Surrender Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="surrender_date" />
            </div>

            <!-- Complete Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Complete Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="complete_date" />
            </div>

            <!-- Docs Released Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Docs Released Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="docs_released_date" />
            </div>

            <!-- Tracking Number -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Tracking Number</label>
              <input type="text" class="form-control form-control-solid" formControlName="tracking_number"
                placeholder="Enter tracking number" />
            </div>

            <!-- Status -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Status</label>
              <select class="form-select form-select-solid" formControlName="status"
                [class.is-invalid]="status?.invalid && status?.touched">
                <option value="">Select Status</option>
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
                <option value="Cancelled">Cancelled</option>
              </select>
              <div class="invalid-feedback" *ngIf="status?.invalid && status?.touched">
                <span *ngIf="status?.errors?.['required']">Status is required</span>
              </div>
            </div>

            <!-- Remarks -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Remarks</label>
              <textarea class="form-control form-control-solid" formControlName="remarks" rows="3"
                placeholder="Enter remarks"></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="isLoading">
            <span class="indicator-label">{{ isEditMode ? 'Update' : 'Save' }}</span>
            <span class="indicator-progress" *ngIf="isLoading">
              Please wait...
              <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!--end::Modal - Add/Edit Courier Manager-->
